import { CloudOff, CloudUpload, RefreshCw } from "lucide-react";
import { Link } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { lastOfflineRefresh } from "../offline/warmCache";
import { useOfflineStatus, useOutboxItems } from "../offline/runtime";

/** Faixa de situação da conexão e das vistorias guardadas no aparelho. */
export function OfflineStatus() {
  const { user } = useAuth();
  const { online, syncing } = useOfflineStatus();
  const { items } = useOutboxItems(user?.id);
  const review = items.filter((item) => item.status === "precisa_revisao").length;
  const waiting = items.length - review;
  if (online && !items.length) return null;

  const refreshedAt = lastOfflineRefresh();
  return <div className={`offline-status ${online ? "pending" : "offline"}`} role="status" aria-live="polite">
    {!online
      ? <><CloudOff size={17} aria-hidden="true"/><span><strong>Sem conexão.</strong> Você pode consultar cadastros e registrar vistorias; elas serão enviadas quando a internet voltar.{refreshedAt ? ` Cadastros atualizados em ${new Date(refreshedAt).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" })}.` : ""}</span></>
      : <>{syncing ? <RefreshCw size={17} className="spin" aria-hidden="true"/> : <CloudUpload size={17} aria-hidden="true"/>}<span><strong>{syncing ? "Enviando vistorias…" : `${items.length} vistoria(s) neste aparelho.`}</strong>{!syncing && waiting ? ` ${waiting} aguardando envio.` : ""}{review ? ` ${review} precisa(m) de revisão.` : ""}</span></>}
    {items.length > 0 && <Link to="/pendentes">Ver pendentes{items.length ? ` (${items.length})` : ""}</Link>}
  </div>;
}
